module.exports = __webpack_public_path__ + "img/viz-table.91e2a400.svg";